import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

import { getJbpGlobalPartnerDetails } from '../components/globalPartnerTable/helpers/getJbpGlobalPartnerDetails'

interface IAddPartnersToGlobalPartnerParameters {
  globalPartnerId: string
  partnerIds: string[]
  currentFYear: number
}

export const addPartnersToGlobalPartner = async ({
  globalPartnerId,
  partnerIds,
  currentFYear,
}: IAddPartnersToGlobalPartnerParameters) => {
  const crud = getJbpGlobalPartnerDetails(globalPartnerId)

  const url = proxy(`/webservice/197/sp/v4/spJBPGlobalPartnersAddPartners/call`)

  const payload = {
    'p.GlobalPartnerId': globalPartnerId,
    'p.FYear': currentFYear,
    'p.PartnerIds': JSON.stringify(partnerIds),
  }
  const {
    app: { ownerId },
  } = appGetState()
  const [accessToken] = getTokens(ownerId)

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }
  await Rest.post({ url, payload, headers })

  crud.removeQueries(true)
}
